import { Component, OnInit, Input, ElementRef, ViewChild, Renderer } from '@angular/core';
import { FileUploadService } from '../../api/services/file-upload.service';

@Component({
  selector: 'app-file-download',
  templateUrl: './file-download.component.html',
  styleUrls: ['./file-download.component.scss']
})
export class FileDownloadComponent implements OnInit {


  @Input() fileId: string;
  @ViewChild('downloadAnchor') anchor: ElementRef;

  constructor(private renderer: Renderer, private fileUploadService: FileUploadService) { }

  download() {
    this.fileUploadService.get(this.fileId)
    .subscribe(file => {
      this.anchor.nativeElement.href = file.url;
      this.renderer.invokeElementMethod(
        this.anchor.nativeElement, 'click', []);
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/file-download/file-download.component.ts